import { memo } from 'react';
import PropTypes from 'prop-types';
import UserAvatar from '../../userAvatar';

const User = ({ user, isAccessible, onGoToProfilePage }) => {
  return (
    <UserAvatar
      user={user}
      variant="subtitle1"
      clickableCaption={isAccessible}
      onClickHandler={onGoToProfilePage(user)}
      small
      caption
    />
  );
};

User.propTypes = {
  user: PropTypes.object.isRequired,
  isAccessible: PropTypes.bool.isRequired,
  onGoToProfilePage: PropTypes.func.isRequired,
};

export default memo(User);
